module.exports = __webpack_public_path__ + "img/inventory_report.de86c16f.png";